import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { getCanalDistribuicao, getCidade, getContexto, getEmpresa, getReflex, getPosicaoCarga, getAutosservico, getCreditoCliente, getForcaVenda, getErroPesquisa, getErroPesquisaVendedor, getBateuLevou, getSuper4, getVloz, getPassouGanhou, getGvFaturamento, getClienteShare, getEstado, getFamiliaMaterial, getFilial, getGrupoCentralizador, getGrupoMaterial, getSubGrupoMaterial, getGrupoSegmento, getHierarquiaAprovacao, getLocal, getMotivo, getParametro, getPesquisaCanalDistribuicao, getPesquisaEmbalagem, getPesquisaGrupoMaterial, getPesquisaGrupoMaterialCanalDistribuicao, getPesquisaGrupoMaterialEmbalagem, getPesquisaGrupoMaterialPlayer, getPesquisaGrupoMaterialPrazo, getPesquisaGrupoMaterialUnidadeMedida, getPesquisaPlayer, getPesquisaPrazo, getPesquisaProdutos, getPesquisaUnidadeMedida, getPrazoPagamento, getPrecoCliente, getPrecoRegra, getProduto, getProdutoFilial, getSegmento, getServico, getSimulacao, getTipoCondicao, getTrilha, getUnidadeMedida, getDocumentos, getFunilObraGrupoProdutos, getFunilObraProdutos, getPesquisaCentroOrigem, getProdutosConcorrente, getPesquisaGruposObrigatorios, getPesquisaMotivoCompra, getUltimosUploadsDocumentos, getPesquisaPlayerCentroOrigem, getCargos, getMicrorregiao, getClusters, getPrazoRegra, getFunilStatus, getFunilStatusGrupo, getTabelaPreco, getTabelaPrecoCliente, getMapaMina, getCarteira, getMotivoPerda, getNivelServico, getFunilObraConsorcio, getFunilObraEmpresaLider, getInfoTatica, getFaturamento, getMissao, getRota, getVisita, getFunilObraFonteCaptacao, getFunilObraJustificativa, getGov, getRotaDoDia, getLocalTrilha, getVendedor, getEquipeVenda, getEscritorioVenda, getAreaVendaVendedor, getParametroReflex, getUltimaVisita, getDuplaCategoria, getFunilObraUnidadeMedidas, getFunilObraGrupoProdutoUnidadeMedida, getFunilObras, getFunilObraMotivoPerda, getFunilObraConcorrente, getFunilObraGrupoProdutoMapeamentoInicial } from "~services/SincronizacaoServices";


const useDataFetch = (queryKey, fetchFunction, enabled, additionalQueryOptions = {}) => {
  const queryClient = useQueryClient();

  const queryResult = useQuery(queryKey, fetchFunction, {
    enabled,
    cacheTime: 0,
    ...additionalQueryOptions
  });

  const clearCache = () => {
    queryClient.removeQueries(queryKey);
  };

  return { ...queryResult, clearCache };
};

export const useGetFunilStatus = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(["funil-status"], useCallback(() => getFunilStatus(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]), enable);
};


export const useGetReflex = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["reflex"],
    useCallback(() => getReflex(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetPosicaoCarga = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["posicaoCarga"],
    useCallback(() => getPosicaoCarga(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetAutosservico = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["autosservico"],
    useCallback(() => getAutosservico(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetCreditoCliente = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["creditoCliente"],
    useCallback(() => getCreditoCliente(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetForcaVenda = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["forcaVenda"],
    useCallback(() => getForcaVenda(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetErroPesquisa = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["erroPesquisa"],
    useCallback(() => getErroPesquisa(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetErroPesquisaVendedor = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["erroPesquisaVendedor"],
    useCallback(() => getErroPesquisaVendedor(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetBateuLevou = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["bateuLevou"],
    useCallback(() => getBateuLevou(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetSuper4 = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["super4"],
    useCallback(() => getSuper4(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetVloz = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["vloz"],
    useCallback(() => getVloz(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetPassouGanhou = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["passouGanhou"],
    useCallback(() => getPassouGanhou(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetGvFaturamento = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["gvFaturamento"],
    useCallback(() => getGvFaturamento(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetClienteShare = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["clienteShare"],
    useCallback(() => getClienteShare(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};

export const useGetParametroReflex = (enable, take, skip, dataAtualizacao) => {
  return useDataFetch(
    ["parametroReflex"],
    useCallback(() => getParametroReflex(take, skip, dataAtualizacao), [skip, take, dataAtualizacao]),
    enable
  );
};


export const useGetGov = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["gov"], useCallback(() => getGov(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilStatusGrupo = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-status-grupo"], useCallback(() => getFunilStatusGrupo(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraFonteCaptacao = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-fonte-captacao"], useCallback(() => getFunilObraFonteCaptacao(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraJustificativa = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-justificativa"], useCallback(() => getFunilObraJustificativa(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraUnidadeMedida = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-obra-unidade-medida"], useCallback(() => getFunilObraUnidadeMedidas(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraGrupoProdutoUnidadeMedida = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-obra-grupo-produto-unidade-medida"], useCallback(() => getFunilObraGrupoProdutoUnidadeMedida(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraMotivoPerda = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-obra-motivo-perda"], useCallback(() => getFunilObraMotivoPerda(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraGrupoProdutoMapeamentoInicial = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funil-obra-motivo-perda"], useCallback(() => getFunilObraGrupoProdutoMapeamentoInicial(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetClusters = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["clusters"], useCallback(() => getClusters(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetMicrorregiao = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["microrregiao"], useCallback(() => getMicrorregiao(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetProdutosConcorrente = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["produtosConcorrente", skip, take], useCallback(() => getProdutosConcorrente(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetSimulacoes = (enable, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["simulacoes", skip, take], useCallback(() => getSimulacao(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetHierarquiasAprovacao = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["hierarquias-aprovacao"], useCallback(() => getHierarquiaAprovacao(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGrupoMaterialCanalDistribuicao = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGrupoMaterialCanalDistribuicao", skip, take], useCallback(() => getPesquisaGrupoMaterialCanalDistribuicao(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGrupoMaterialPlayer = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGrupoMaterialPlayer", skip, take], useCallback(() => getPesquisaGrupoMaterialPlayer(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGrupoMaterialPrazo = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGrupoMaterialPrazo", skip, take], useCallback(() => getPesquisaGrupoMaterialPrazo(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGrupoMaterial = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGrupoMaterial", skip, take], useCallback(() => getPesquisaGrupoMaterial(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGrupoMaterialUnidadeMedida = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGrupoMaterialUnidadeMedida", skip, take], useCallback(() => getPesquisaGrupoMaterialUnidadeMedida(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGrupoMaterialEmbalagem = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGrupoMaterialEmbalagem", skip, take], useCallback(() => getPesquisaGrupoMaterialEmbalagem(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaCentroOrigem = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaCentroOrigem", skip, take], useCallback(() => getPesquisaCentroOrigem(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaGruposObrigatorios = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaGruposObrigatorios", skip, take], useCallback(() => getPesquisaGruposObrigatorios(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaPlayerCentroOrigem = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaPlayerCentroOrigem", skip, take], useCallback(() => getPesquisaPlayerCentroOrigem(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetFunilObraGrupoProdutos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funilObra-grupoProdutos", skip, take], useCallback(() => getFunilObraGrupoProdutos(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetFunilObra = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funilObra-produtos", skip, take], useCallback(() => getFunilObras(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetFunilObraProdutos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["funilObra-produtos", skip, take], useCallback(() => getFunilObraProdutos(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPrazoRegra = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["prazo-regra", skip, take], useCallback(() => getPrazoRegra(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPrecoCliente = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["preco-cliente", skip, take], useCallback(() => getPrecoCliente(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPrecoRegra = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["preco-regra", skip, take], useCallback(() => getPrecoRegra(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetDocumentos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["documentos", skip, take], useCallback(() => getDocumentos(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetUltimosUploadsDocumentos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["ultimosUploadsDocumentos", skip, take], useCallback(() => getUltimosUploadsDocumentos(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetCargos = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["cargos"], useCallback(() => getCargos(take, skip, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enable);
}

export const useGetFiliais = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["filiais"], useCallback(() => getFilial(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetProdutos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["produtos", skip, take], useCallback(() => getProduto(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetServico = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["servicos"], useCallback(() => getServico(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetProdutosFiliais = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["produtosPorFilial", skip, take], useCallback(() => getProdutoFilial(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetGrupoProdutos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["grupoProdutos", skip, take], useCallback(() => getGrupoMaterial(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetSubGrupoProdutos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["subGrupoProdutos", skip, take], useCallback(() => getSubGrupoMaterial(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetFamiliaProduto = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["familiaProdutos", skip, take], useCallback(() => getFamiliaMaterial(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetUnidadeMedidas = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["unidadesMedida", skip, take], useCallback(() => getUnidadeMedida(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetMotivos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["motivos", skip, take], useCallback(() => getMotivo(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetEmpresas = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["empresas", skip, take], useCallback(() => getEmpresa(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetEquipeVenda = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["equipesVenda", skip, take], useCallback(() => getEquipeVenda(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetEscritorioVenda = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["escritoriosVenda", skip, take], useCallback(() => getEscritorioVenda(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetAreaVendaVendedor = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["areasVendaVendedor", skip, take], useCallback(() => getAreaVendaVendedor(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetTrilhas = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["trilhas", skip, take], useCallback(() => getTrilha(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPrazoPagamentos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["prazosPagamento"], useCallback(() => getPrazoPagamento(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetTipoCondicao = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["tipoCondicoes"], useCallback(() => getTipoCondicao(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetGruposCentralizadores = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["gruposCentralizadores", skip, take], useCallback(() => getGrupoCentralizador(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetGrupoSegmentos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["gruposSegmentos", skip, take], useCallback(() => getGrupoSegmento(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetSegmentos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["segmentos"], useCallback(() => getSegmento(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetCidades = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["cidades"], useCallback(() => getCidade(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetEstados = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["estados"], useCallback(() => getEstado(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetContextos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["contextos"], useCallback(() => getContexto(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetLocais = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["locais"], useCallback(() => getLocal(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetLocalTrilhas = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["localTrilhas"], useCallback(() => getLocalTrilha(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetVendedores = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["vendedores"], useCallback(() => getVendedor(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetParametros = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["parametros"], useCallback(() => getParametro(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetCanalDistribuicao = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["canaisDistribuicao"], useCallback(() => getCanalDistribuicao(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaUnidadeMedidas = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaUnidadesMedida", skip, take], useCallback(() => getPesquisaUnidadeMedida(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaPrazos = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaPrazo", skip, take], useCallback(() => getPesquisaPrazo(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaEmbalagem = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaEmbalagem", skip, take], useCallback(() => getPesquisaEmbalagem(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaCanalDistribuicao = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaCanalDistribuicao", skip, take], useCallback(() => getPesquisaCanalDistribuicao(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaMotivoCompra = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaMotivoCompra", skip, take], useCallback(() => getPesquisaMotivoCompra(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaPlayer = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaPlayer", skip, take], useCallback(() => getPesquisaPlayer(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetPesquisaProduto = (enabled, skip, take, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["pesquisaProduto", skip, take], useCallback(() => getPesquisaProdutos(skip, take, dataAtualizacao, vendedorSelecionado), [skip, take, dataAtualizacao, vendedorSelecionado]), enabled);
};

export const useGetTabelaPreco = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["ordenacao-tabela-preco"], useCallback(() => getTabelaPreco(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetTabelaPrecoCliente = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(["tabela-preco-cliente"], useCallback(() => getTabelaPrecoCliente(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetMapaMina = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['mapa-mina', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getMapaMina(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetCarteira = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['carteira', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getCarteira(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetMotivoPerda = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['motivoPerda', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getMotivoPerda(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraConcorrente = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['concorrente', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getFunilObraConcorrente(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraConsorcio = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['consorcio', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getFunilObraConsorcio(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetFunilObraEmpresaLider = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['empresaLider', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getFunilObraEmpresaLider(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetNivelServico = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  return useDataFetch(['nivelServico', take, skip, dataAtualizacao, vendedorSelecionado], useCallback(() => getNivelServico(take, skip, dataAtualizacao, vendedorSelecionado), [take, skip, dataAtualizacao, vendedorSelecionado]), enable);
};

export const useGetRotas = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const rota = useQuery(["rota"], () => getRota(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["rota"]);
  };

  return { ...rota, clearCache };
};

export const useGetRotasDoDia = (enable, take, skip) => {
  const rota = useQuery(["rota-do-dia"], () => getRotaDoDia(), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["rota-do-dia"]);
  };

  return { ...rota, clearCache };
};

export const useGetMissoes = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const missao = useQuery(["missao"], () => getMissao(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["missao"]);
  };

  return { ...missao, clearCache };
};

export const useGetInfosTatica = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const infoTatica = useQuery(["info-tatica"], () => getInfoTatica(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["info-tatica"]);
  };

  return { ...infoTatica, clearCache };
};

export const useGetFaturamentos = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const faturamento = useQuery(["faturamento"], () => getFaturamento(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["faturamento"]);
  };

  return { ...faturamento, clearCache };
};

export const useGetVisitas = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const visita = useQuery(["visita"], () => getVisita(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["visita"]);
  };

  return { ...visita, clearCache };
};

export const useGetUltimaVisitas = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const ultimaVisita = useQuery(["ultima-visita"], () => getUltimaVisita(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["ultima-visita"]);
  };

  return { ...ultimaVisita, clearCache };
};

export const useGetDuplaCategoria = (enable, take, skip, dataAtualizacao, vendedorSelecionado = null) => {
  const duplaCategoria = useQuery(["dupla-categoria"], () => getDuplaCategoria(take, skip, dataAtualizacao, vendedorSelecionado), {
    enabled: enable,
  });
  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["dupla-categoria"]);
  };

  return { ...duplaCategoria, clearCache };
};
